import { Record, List } from 'immutable';

import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';

const State = new Record({
    search: null,
    loading: true,
    fares: new List()
});

export class SeasonTicketsStore extends BaseStore {

    getInitialState () {
        return new State();
    }

    getKey(search) {
        return JSON.stringify(search.serialize());
    }

    isCurrentSearch (search) {
        return this.state.search && this.getKey(search) === this.getKey(this.state.search);
    }

    get fares () {
        return this.state.fares;
    }

    get loading () {
        return this.state.loading;
    }

    handleSearchStarted ({ search }) {
        this.setState(new State({ search }));
    }

    handlePointSearchFinished ({ search, seasonTickets }) {
        this.handleSearchFinished(search, seasonTickets);
    }

    handleFareSearchFinished ({ search, fares }) {
        this.handleSearchFinished(search, fares);
    }

    handleSearchFinished (search, fares) {
        const updated = this.state
            .set('loading', false)
            .set('search', search)
            .set('fares', fares);

        this.setState(updated);
    }

    getActionHandlers () {
        return {
            [ActionTypes.SEASON_SEARCH_STARTED]: this.handleSearchStarted,
            [ActionTypes.SEASON_SEARCH_FINISHED]: this.handlePointSearchFinished,
            [ActionTypes.FARE_ONLY_SEASON_SEARCH_STARTED]: this.handleSearchStarted,
            [ActionTypes.FARE_ONLY_SEASON_SEARCH_FINISHED]: this.handleFareSearchFinished
        };
    }
}

const storeInstance = new SeasonTicketsStore();

export default storeInstance;



// WEBPACK FOOTER //
// ./src/stores/SeasonTicketsStore.js